import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { texteEnLangue } from '@artosera/shared';
import type { ArticlePresente } from '../../api/presse.js';
import { useExposition } from '../../api/expositions.js';
import { useArtiste } from '../../api/artistes.js';
import { useOeuvre } from '../../api/oeuvres.js';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import styles from './PressePage.module.css';
export function LiensPresse({ article }: { article: ArticlePresente }) {
  return (
    <div className={styles.liens}>
      {(['expositions', 'artistes', 'oeuvres'] as const).flatMap((type) =>
        article[type].map((id) => <Reference key={`${type}:${id}`} type={type} id={id} />),
      )}
    </div>
  );
}
function Reference({ type, id }: { type: 'expositions' | 'artistes' | 'oeuvres'; id: string }) {
  const { galerieSlug, galerie } = useShellContext();
  const { t, i18n } = useTranslation(['regie']);
  const permis = galerieALaction(
    galerie,
    type === 'expositions'
      ? 'exhibitions:read'
      : type === 'artistes'
        ? 'artists:read'
        : 'artworks:read',
  );
  const exposition = useExposition(galerieSlug, type === 'expositions' && permis ? id : null);
  const artiste = useArtiste(galerieSlug, type === 'artistes' && permis ? id : null);
  const oeuvre = useOeuvre(galerieSlug, type === 'oeuvres' && permis ? id : null);
  if (!permis) return null;
  const nom = exposition.data
    ? texteEnLangue(exposition.data.exposition.titre, i18n.language === 'en' ? 'en' : 'fr')
    : (artiste.data?.nom ?? oeuvre.data?.oeuvre.titre ?? t(`regie:presse.references.${type}`));
  return <Link to={`/${galerieSlug}/${type}/${id}`}>{nom}</Link>;
}
